import { AxiosPromise } from 'axios';
import { gfhAPI } from '../httpClient';

interface PendoAccountInfo {
  autoMessages: boolean;
  incomeReports: boolean;
  websiteBuilder: boolean;
  connectedAirbnb: boolean;
  connectedBcom: boolean;
  connectedVrbo: boolean;
  importedAirbnbListings: boolean;
  connectedSmartLock: boolean;
  daysSinceCC: number;
  hasRooms: boolean;
  country: string;
}

const fetchPendoAccountInfo = (): AxiosPromise<PendoAccountInfo> =>
  gfhAPI.get('/pendo/account-info');

export default fetchPendoAccountInfo;
